"use client"

import { useCollectionNativeCurrency } from "@/app/collections/store/use-collection"
import { PriceFilter } from "@/app/nft/search/filters/price-filter"
import { reatomComponent } from "@reatom/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"

export function CollectionItemPriceFilter() {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <PriceFilterContent />
      </Suspense>
    </ErrorBoundary>
  )
}

const PriceFilterContent = reatomComponent(() => {
  const nativeCurrency = useCollectionNativeCurrency()

  return <PriceFilter currency={nativeCurrency} />
}, "PriceFilterContent")
